// @mui material components
import Grid from "@mui/material/Grid";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";

import React, { useState, useEffect } from "react";
import { API_URL } from "../../../../config";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import { toast } from "sonner";

const StatisticsSection = () => {
  const [statistics, setStatistics] = useState({
    totalUsers: 0,
    totalProjects: 0,
    availableSupervisors: 0,
    pendingApprovals: 0,
  });

  useEffect(() => {
    const fetchStatistics = async () => {
      try {
        const response = await fetch(`${API_URL}/statistics/getstatistics`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });

        const stats = await response.json();

        if (response.ok) {
          setStatistics(stats);
        } else {
          console.log("Failed to fetch statistics: Server Error");
        }
      } catch (error) {
        console.log("Failed to fetch statistics: Server Error");
      }
    };

    fetchStatistics();
  }, []);
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={6} lg={3}>
        <MDBox mb={1.5}>
          <ComplexStatisticsCard
            color="dark"
            icon="group"
            title="Total Users"
            count={statistics.totalUsers}
            percentage={{
              label: "Overall",
            }}
          />
        </MDBox>
      </Grid>
      <Grid item xs={12} md={6} lg={3}>
        <MDBox mb={1.5}>
          <ComplexStatisticsCard
            icon="leaderboard"
            title="Total Projects"
            count={statistics.totalProjects}
            percentage={{
              label: "Overall",
            }}
          />
        </MDBox>
      </Grid>
      <Grid item xs={12} md={6} lg={3}>
        <MDBox mb={1.5}>
          <ComplexStatisticsCard
            color="success"
            icon="supervisor"
            title="Avaialable Supervisors"
            count={statistics.availableSupervisors}
            percentage={{
              color: "success",
              amount: "",
              label: "Overall",
            }}
          />
        </MDBox>
      </Grid>
      <Grid item xs={12} md={6} lg={3}>
        <MDBox mb={1.5}>
          <ComplexStatisticsCard
            color="primary"
            icon="person_add"
            title="Pending Approvals"
            count={statistics.pendingApprovals}
            percentage={{
              color: "success",
              amount: "",
              label: "Pending Project Approvals",
            }}
          />
        </MDBox>
      </Grid>
    </Grid>
  );
};

export default StatisticsSection;
